<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="650px"
      :persistent="true"
    >
      <v-card
        class="pa-3"
        style="border-radius: 7px;"
        elevation="10"
      >
        <v-card-title>
          <v-row>
            <v-col cols="auto">
              <span style="font-weight: bold; font-size: 26px;">{{ title }}</span>
            </v-col>
            <v-col class="text-end pt-0">
              <v-btn
                icon
                @click="cancel"
                color="#000000"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <span style="color: black; font-size: 18px;">{{ message }}</span>
        </v-card-text>
        <v-card-actions class="pr-2">
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            text
            @click="cancel"
          >
            <span style="font-size: 18px;">{{ cancelBtn }}</span>
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirm"
          >
            <span style="font-size: 18px;">{{ confirmBtn }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  data: () => ({
    title: 'Confirmation',
    message: '',
    confirmBtn: 'Submit',
    cancelBtn: 'Cancel',
    dialog: false,
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {

    open(options = {}) {
      if (options.title) this.title = options.title;
      if (options.message) this.message = options.message;
      if (options.confirmBtn) this.confirmBtn = options.confirmBtn;
      if (options.cancelBtn) this.cancelBtn = options.cancelBtn;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    confirm() {
      this.dialog = false;
      this.resolvePromise(true);
    },

    cancel() {
      this.dialog = false;
      this.resolvePromise(false);
    },
  },
};
</script>
